import { useOnScreen } from '@avensia/excite-ui';
import { styled } from '@glitz/react';
import * as React from 'react';

type videoProp = {
  url: string;
  autoPlay?: boolean;
  loop?: boolean;
  controls?: boolean;
};

export const Video = styled(({ controls = true, ...props }: videoProp) => {
  const [isInViewport, ref] = useOnScreen<HTMLVideoElement>();
  const [isLoaded, setIsLoaded] = React.useState(false);

  const sourceRef = React.useRef<HTMLSourceElement>(null);

  const onLoad = React.useCallback(() => {
    setIsLoaded(true);
    const aspect = `${ref.current?.videoWidth} / ${ref.current?.videoHeight}`;
    ref.current?.style.setProperty('aspect-ratio', aspect);
  }, [ref]);

  React.useEffect(() => {
    if (isInViewport && sourceRef.current) {
      sourceRef.current.src = props?.url;
      ref.current?.load();
    }
  }, [isInViewport, props?.url, ref]);

  if (!props?.url) {
    return null;
  }

  return (
    <VideoWrapper>
      <VideoElement
        ref={ref}
        css={isLoaded && noBackdropDecorator}
        autoPlay={props.autoPlay}
        loop={props.loop}
        playsInline={props.autoPlay}
        muted={props.autoPlay}
        onLoadedMetadata={onLoad}
        controls={controls}
        disablePictureInPicture
        controlsList="nodownload noplaybackrate"
      >
        <source ref={sourceRef} />
      </VideoElement>
    </VideoWrapper>
  );
});

const noBackdropDecorator = styled({ backgroundColor: 'transparent' });
const VideoWrapper = styled.div({ position: 'relative', width: '100%', height: '100%' });

const VideoElement = styled.video({
  width: '100%',
  height: '100%',
  aspectRatio: '16 / 9',
  objectFit: 'contain',
  backgroundColor: t => t.darkGrey,
});
